module.exports = __webpack_public_path__ + "static/img/handmaid.9332586.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/handmaid.jpg
// module id = 8Zz3
// module chunks = 1